// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__72rjo","checkboxCol":"Table_checkboxCol__e-qGX","emailCol":"Table_emailCol__2XYUR","actionCol":"Table_actionCol__39QoN"};